import { useCallback, useState } from 'react';
import { reelService } from 'api/services/ReelService';

export interface UseSaveReelResult {
  toggleSave: (reelId: string, currentlySaved: boolean) => Promise<boolean>;
  loading: boolean;
  error: string | null;
  resetError: () => void;
}

export function useSaveReel(): UseSaveReelResult {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const resetError = useCallback(() => setError(null), []);

  const toggleSave = useCallback(async (reelId: string, currentlySaved: boolean): Promise<boolean> => {
    setLoading(true);
    setError(null);
    try {
      const result = currentlySaved
        ? await reelService.unsave(reelId)
        : await reelService.save(reelId);
      if (!result.isSuccess) {
        setError(result.message ?? 'İşlem tamamlanamadı.');
        return false;
      }
      return true;
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Bir hata oluştu.');
      return false;
    } finally {
      setLoading(false);
    }
  }, []);

  return { toggleSave, loading, error, resetError };
}
